/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { ContactOutput } from "../../models/contact-output";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface GetCustomerContactPersons$Params {
  customer_id: string;
}

export function getCustomerContactPersons(
  http: HttpClient,
  rootUrl: string,
  params: GetCustomerContactPersons$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<ContactOutput>>> {
  const rb = new RequestBuilder(rootUrl, getCustomerContactPersons.PATH, "get");
  if (params) {
    rb.path("customer_id", params.customer_id, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json; charset&#x3D;utf-8", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ContactOutput>>;
    }),
  );
}

getCustomerContactPersons.PATH = "/dashboard/customers/{customer_id}/contact_persons";
